import './index.css'
import ChooseDate from "./components/ChooseDate/ChooseDate";
import Table from "./components/Table/Table";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ThunkSetUsers} from "./store/Thunks/ThunkSetUsers";
import Loading from "./components/Loading/Loading";
import {ThunkCheckDepartment} from "./store/Thunks/ThunkCheckDepartment";
import TableSingle from "./components/TableSingle/TableSingle";
import ModalAddTask from "./components/ModalAddTask/ModalAddTask";
import {Button} from "@mui/material";

function App() {

    const dispatch = useDispatch()
    const {loading, admin, data_about_users} = useSelector(state => state.main)

    const [openModal, setOpenModal] = useState(false)

    useEffect(() => {
        dispatch(ThunkSetUsers())
        dispatch(ThunkCheckDepartment())
    }, [])

    return (
        <div className="App">
            {loading && <Loading />}
            <div className={'m-auto'}>
                <div className={'text-center my-4 text-4xl text-black'}>Календарь замеров</div>
                <div className={'text-center text-gray-500 text-2xl'}>Выберите диапозон дат</div>

                {openModal && <ModalAddTask setValue={setOpenModal} />}

                <ChooseDate />

                {admin && <div onClick={() => setOpenModal(true)} className={'flex justify-center mt-8'}><Button variant={'contained'}>Создать задачу</Button></div>}

                {(admin) ? <Table /> : <TableSingle />}
            </div>
        </div>
    );
}

export default App;
